import sectionSocialMediaCss from '../css-snippets/section-social-media';

const html = ` 
<style>${sectionSocialMediaCss}</style>
<div
  class="social-media-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="social-media-container container">
    <div class="social-media-title">
      <h2 style="text-align: center"><strong>It's Going Viral on Social Media</strong></h2>
    </div>
    <div class="social-media-posts">
      <div class="post-item-wrapper">
        <div class="post-item">
          <div class="post-info">
            <div class="post-author-info-wrapper">
              <div class="post-author">
                <div class="post-author-avatar">
                  <img
                    src="https://cdn.latteprint.com/latte/2025-08-22/1755856881449-181.jpg"
                    alt="avatar"
                  />
                </div>
                <div class="post-author-info">
                  <h3 class="post-author-name">Aria N.</h3>
                  <div class="post-author-time">
                    <p class="post-author-time-text">27 days ago</p>
                    <svg
                      viewBox="0 0 16 16"
                      width="12"
                      height="12"
                      fill="currentColor"
                      title="Public"
                      class="post-author-public-icon"
                    >
                      <g fill-rule="evenodd" transform="translate(-448 -544)">
                        <g>
                          <path
                            d="M109.5 408.5c0 3.23-2.04 5.983-4.903 7.036l.07-.036c1.167-1 1.814-2.967 2-3.834.214-1 .303-1.3-.5-1.96-.31-.253-.677-.196-1.04-.476-.246-.19-.356-.59-.606-.73-.594-.337-1.107.11-1.954.223a2.666 2.666 0 0 1-1.15-.123c-.007 0-.007 0-.013-.004l-.083-.03c-.164-.082-.077-.206.006-.36h-.006c.086-.17.086-.376-.05-.529-.19-.214-.54-.214-.804-.224-.106-.003-.21 0-.313.004l-.003-.004c-.04 0-.084.004-.124.004h-.037c-.323.007-.666-.034-.893-.314-.263-.353-.29-.733.097-1.09.28-.26.863-.8 1.807-.22.603.37 1.166.667 1.666.5.33-.11.48-.303.094-.87a1.128 1.128 0 0 1-.214-.73c.067-.776.687-.84 1.164-1.2.466-.356.68-.943.546-1.457-.106-.413-.51-.873-1.28-1.01a7.49 7.49 0 0 1 6.524 7.434"
                            transform="translate(354 143.5)"
                          ></path>
                          <path
                            d="M104.107 415.696A7.498 7.498 0 0 1 94.5 408.5a7.48 7.48 0 0 1 3.407-6.283 5.474 5.474 0 0 0-1.653 2.334c-.753 2.217-.217 4.075 2.29 4.075.833 0 1.4.561 1.333 2.375-.013.403.52 1.78 2.45 1.89.7.04 1.184 1.053 1.33 1.74.06.29.127.65.257.97a.174.174 0 0 0 .193.096"
                            transform="translate(354 143.5)"
                          ></path>
                          <path
                            fill-rule="nonzero"
                            d="M110 408.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-1 0a7 7 0 1 0-14 0 7 7 0 0 0 14 0z"
                            transform="translate(354 143.5)"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="post-more-icon"
              >
                <circle cx="12" cy="12" r="1" />
                <circle cx="19" cy="12" r="1" />
                <circle cx="5" cy="12" r="1" />
              </svg>
            </div>
            <p class="post-content">
              This lizard is a miracle worker for my anxious dog! We've tried
              everything to help with his separation anxiety. Now, we turn this
              on for 15 minutes when we leave. He's so focused on chasing it
              that he doesn't panic. We come home to a calm pup and a tired-out
              lizard!
            </p>
          </div>
          <div class="post-reaction">
            <div class="post-reaction-wrapper">
              <div class="post-reaction-icon">
                <img
                  src="https://cdn.skyfastimg.com/images/2025/12/10/image-6938daeeed5eebf85bc3aff7.png?w=50&h=50&q=80"
                  alt="like"
                />
                <img
                  src="https://cdn.skyfastimg.com/images/2025/12/10/image-6938db0ac39e3e75f6eac0bb.png?w=50&h=50&q=80"
                  alt="love"
                />
                <img
                  src="https://cdn.skyfastimg.com/images/2025/12/10/image-6938db203759502aae341d01.png?w=50&h=50&q=80"
                  alt="laugh"
                />
                <p class="post-reaction-likes-count">21</p>
              </div>
              <p class="post-reaction-comments-count">
                <span class="post-reaction-comments-count-number">2</span>
                Comments
              </p>
            </div>
            <div class="post-reaction-button-wrapper">
              <div class="post-reaction-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="post-reaction-button-icon"
                >
                  <path d="M7 10v12" />
                  <path
                    d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
                  />
                </svg>
                <p>Like</p>
              </div>
              <div class="post-reaction-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="post-reaction-button-icon"
                >
                  <path
                    d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
                  />
                </svg>
                <p>Comment</p>
              </div>
            </div>
          </div>
          <div class="post-comments">
            <div class="post-comment-item">
              <div class="post-comment-avatar">
                <img
                  src="https://cdn.latteprint.com/latte/2025-08-22/1755856692804-67.jpg"
                  alt="avatar"
                />
              </div>
              <div class="post-comment-content">
                <div class="post-comment-content-header">
                  <h5 class="post-comment-content-header-name">Naomi V.</h5>
                  <p class="post-comment-content-header-text">
                    Does it work on hardwood floors? Our tiles are pretty slick
                  </p>
                </div>
                <div class="post-comment-content-footer">
                  <p class="post-comment-content-footer-like">Like</p>
                  <p class="post-comment-content-footer-reply">Reply</p>
                  <p class="post-comment-content-footer-time">26 days ago</p>
                </div>
              </div>
            </div>
            <div class="post-comment-item">
              <div class="post-comment-avatar">
                <img
                  src="https://cdn.latteprint.com/latte/2025-08-22/1755856958153-243.jpg"
                  alt="avatar"
                />
              </div>
              <div class="post-comment-content">
                <div class="post-comment-content-header">
                  <h5 class="post-comment-content-header-name">Bryan D.</h5>
                  <p class="post-comment-content-header-text">
                    Yes! It actually grips really well and the auto-steering
                    helps it not get stuck. It handles our kitchen floors like a
                    champ.
                  </p>
                </div>
                <div class="post-comment-content-footer">
                  <p class="post-comment-content-footer-like">Like</p>
                  <p class="post-comment-content-footer-reply">Reply</p>
                  <p class="post-comment-content-footer-time">26 days ago</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="post-item-wrapper">
        <div class="post-item">
          <div class="post-info">
            <div class="post-author-info-wrapper">
              <div class="post-author">
                <div class="post-author-avatar">
                  <img
                    src="https://cdn.latteprint.com/latte/2025-08-22/1755856765657-85.jpg"
                    alt="avatar"
                  />
                </div>
                <div class="post-author-info">
                  <h3 class="post-author-name">Thalia S.</h3>
                  <div class="post-author-time">
                    <p class="post-author-time-text">14 hours ago</p>
                    <svg
                      viewBox="0 0 16 16"
                      width="12"
                      height="12"
                      fill="currentColor"
                      title="Public"
                      class="post-author-public-icon"
                    >
                      <g fill-rule="evenodd" transform="translate(-448 -544)">
                        <g>
                          <path
                            d="M109.5 408.5c0 3.23-2.04 5.983-4.903 7.036l.07-.036c1.167-1 1.814-2.967 2-3.834.214-1 .303-1.3-.5-1.96-.31-.253-.677-.196-1.04-.476-.246-.19-.356-.59-.606-.73-.594-.337-1.107.11-1.954.223a2.666 2.666 0 0 1-1.15-.123c-.007 0-.007 0-.013-.004l-.083-.03c-.164-.082-.077-.206.006-.36h-.006c.086-.17.086-.376-.05-.529-.19-.214-.54-.214-.804-.224-.106-.003-.21 0-.313.004l-.003-.004c-.04 0-.084.004-.124.004h-.037c-.323.007-.666-.034-.893-.314-.263-.353-.29-.733.097-1.09.28-.26.863-.8 1.807-.22.603.37 1.166.667 1.666.5.33-.11.48-.303.094-.87a1.128 1.128 0 0 1-.214-.73c.067-.776.687-.84 1.164-1.2.466-.356.68-.943.546-1.457-.106-.413-.51-.873-1.28-1.01a7.49 7.49 0 0 1 6.524 7.434"
                            transform="translate(354 143.5)"
                          ></path>
                          <path
                            d="M104.107 415.696A7.498 7.498 0 0 1 94.5 408.5a7.48 7.48 0 0 1 3.407-6.283 5.474 5.474 0 0 0-1.653 2.334c-.753 2.217-.217 4.075 2.29 4.075.833 0 1.4.561 1.333 2.375-.013.403.52 1.78 2.45 1.89.7.04 1.184 1.053 1.33 1.74.06.29.127.65.257.97a.174.174 0 0 0 .193.096"
                            transform="translate(354 143.5)"
                          ></path>
                          <path
                            fill-rule="nonzero"
                            d="M110 408.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-1 0a7 7 0 1 0-14 0 7 7 0 0 0 14 0z"
                            transform="translate(354 143.5)"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="post-more-icon"
              >
                <circle cx="12" cy="12" r="1" />
                <circle cx="19" cy="12" r="1" />
                <circle cx="5" cy="12" r="1" />
              </svg>
            </div>
            <p class="post-content">
              How long does the battery last per charge?
            </p>
          </div>
          <div class="post-reaction">
            <div class="post-reaction-wrapper">
              <div class="post-reaction-icon">
                <img
                  src="https://cdn.skyfastimg.com/images/2025/12/10/image-6938daeeed5eebf85bc3aff7.png?w=50&h=50&q=80"
                  alt="like"
                />
                <img
                  src="https://cdn.skyfastimg.com/images/2025/12/10/image-6938db0ac39e3e75f6eac0bb.png?w=50&h=50&q=80"
                  alt="love"
                />
                <img
                  src="https://cdn.skyfastimg.com/images/2025/12/10/image-6938db203759502aae341d01.png?w=50&h=50&q=80"
                  alt="laugh"
                />
                <p class="post-reaction-likes-count">46</p>
              </div>
              <p class="post-reaction-comments-count">
                <span class="post-reaction-comments-count-number">2</span>
                Comments
              </p>
            </div>
            <div class="post-reaction-button-wrapper">
              <div class="post-reaction-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="post-reaction-button-icon"
                >
                  <path d="M7 10v12" />
                  <path
                    d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
                  />
                </svg>
                <p>Like</p>
              </div>
              <div class="post-reaction-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="post-reaction-button-icon"
                >
                  <path
                    d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
                  />
                </svg>
                <p>Comment</p>
              </div>
            </div>
          </div>
          <div class="post-comments">
            <div class="post-comment-item">
              <div class="post-comment-avatar">
                <img
                  src="https://cdn.latteprint.com/latte/2025-08-22/1755856947269-235.jpg"
                  alt="avatar"
                />
              </div>
              <div class="post-comment-content">
                <div class="post-comment-content-header">
                  <h5 class="post-comment-content-header-name">Jesse N.</h5>
                  <p class="post-comment-content-header-text">
                    We get about 45 mins of continuous run time, which is more
                    than enough to tire out our high-energy herding dog!
                  </p>
                </div>
                <div class="post-comment-content-footer">
                  <p class="post-comment-content-footer-like">Like</p>
                  <p class="post-comment-content-footer-reply">Reply</p>
                  <p class="post-comment-content-footer-time">8 hours ago</p>
                </div>
              </div>
            </div>
            <div class="post-comment-item">
              <div class="post-comment-avatar">
                <img
                  src="https://cdn.latteprint.com/latte/2025-08-22/1755856852661-172.jpg"
                  alt="avatar"
                />
              </div>
              <div class="post-comment-content">
                <div class="post-comment-content-header">
                  <h5 class="post-comment-content-header-name">Aurelia N.</h5>
                  <p class="post-comment-content-header-text">Good!</p>
                </div>
                <div class="post-comment-content-footer">
                  <p class="post-comment-content-footer-like">Like</p>
                  <p class="post-comment-content-footer-reply">Reply</p>
                  <p class="post-comment-content-footer-time">8 hours ago</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="post-item-wrapper">
        <div class="post-item">
          <div class="post-info">
            <div class="post-author-info-wrapper">
              <div class="post-author">
                <div class="post-author-avatar">
                  <img
                    src="https://cdn.latteprint.com/latte/2025-08-22/1755856947210-223.jpg"
                    alt="avatar"
                  />
                </div>
                <div class="post-author-info">
                  <h3 class="post-author-name">Leander P.</h3>
                  <div class="post-author-time">
                    <p class="post-author-time-text">27 days ago</p>
                    <svg
                      viewBox="0 0 16 16"
                      width="12"
                      height="12"
                      fill="currentColor"
                      title="Public"
                      class="post-author-public-icon"
                    >
                      <g fill-rule="evenodd" transform="translate(-448 -544)">
                        <g>
                          <path
                            d="M109.5 408.5c0 3.23-2.04 5.983-4.903 7.036l.07-.036c1.167-1 1.814-2.967 2-3.834.214-1 .303-1.3-.5-1.96-.31-.253-.677-.196-1.04-.476-.246-.19-.356-.59-.606-.73-.594-.337-1.107.11-1.954.223a2.666 2.666 0 0 1-1.15-.123c-.007 0-.007 0-.013-.004l-.083-.03c-.164-.082-.077-.206.006-.36h-.006c.086-.17.086-.376-.05-.529-.19-.214-.54-.214-.804-.224-.106-.003-.21 0-.313.004l-.003-.004c-.04 0-.084.004-.124.004h-.037c-.323.007-.666-.034-.893-.314-.263-.353-.29-.733.097-1.09.28-.26.863-.8 1.807-.22.603.37 1.166.667 1.666.5.33-.11.48-.303.094-.87a1.128 1.128 0 0 1-.214-.73c.067-.776.687-.84 1.164-1.2.466-.356.68-.943.546-1.457-.106-.413-.51-.873-1.28-1.01a7.49 7.49 0 0 1 6.524 7.434"
                            transform="translate(354 143.5)"
                          ></path>
                          <path
                            d="M104.107 415.696A7.498 7.498 0 0 1 94.5 408.5a7.48 7.48 0 0 1 3.407-6.283 5.474 5.474 0 0 0-1.653 2.334c-.753 2.217-.217 4.075 2.29 4.075.833 0 1.4.561 1.333 2.375-.013.403.52 1.78 2.45 1.89.7.04 1.184 1.053 1.33 1.74.06.29.127.65.257.97a.174.174 0 0 0 .193.096"
                            transform="translate(354 143.5)"
                          ></path>
                          <path
                            fill-rule="nonzero"
                            d="M110 408.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-1 0a7 7 0 1 0-14 0 7 7 0 0 0 14 0z"
                            transform="translate(354 143.5)"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="post-more-icon"
              >
                <circle cx="12" cy="12" r="1" />
                <circle cx="19" cy="12" r="1" />
                <circle cx="5" cy="12" r="1" />
              </svg>
            </div>
            <p class="post-content">
              Bought this for our 7-year-old's birthday. Big hit! But the REAL
              surprise was our cat, who usually ignores all toys. Now they both
              chase it together—it's the first thing they've ever done as a
              team! The LED eyes are super bright and the random patterns keep
              them both guessing. Pure family entertainment!
            </p>
          </div>
          <div class="post-reaction">
            <div class="post-reaction-wrapper">
              <div class="post-reaction-icon">
                <img
                  src="https://cdn.skyfastimg.com/images/2025/12/10/image-6938daeeed5eebf85bc3aff7.png?w=50&h=50&q=80"
                  alt="like"
                />
                <img
                  src="https://cdn.skyfastimg.com/images/2025/12/10/image-6938db0ac39e3e75f6eac0bb.png?w=50&h=50&q=80"
                  alt="love"
                />
                <img
                  src="https://cdn.skyfastimg.com/images/2025/12/10/image-6938db203759502aae341d01.png?w=50&h=50&q=80"
                  alt="laugh"
                />
                <p class="post-reaction-likes-count">21</p>
              </div>
              <p class="post-reaction-comments-count">
                <span class="post-reaction-comments-count-number">4</span>
                Comments
              </p>
            </div>
            <div class="post-reaction-button-wrapper">
              <div class="post-reaction-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="post-reaction-button-icon"
                >
                  <path d="M7 10v12" />
                  <path
                    d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
                  />
                </svg>
                <p>Like</p>
              </div>
              <div class="post-reaction-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="post-reaction-button-icon"
                >
                  <path
                    d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
                  />
                </svg>
                <p>Comment</p>
              </div>
            </div>
          </div>
          <div class="post-comments">
            <div class="post-comment-item">
              <div class="post-comment-avatar">
                <img
                  src="https://cdn.latteprint.com/latte/2025-08-22/1755856958145-245.jpg"
                  alt="avatar"
                />
              </div>
              <div class="post-comment-content">
                <div class="post-comment-content-header">
                  <h5 class="post-comment-content-header-name">Peter M.</h5>
                  <p class="post-comment-content-header-text">
                    Is it loud? Our old electric toy sounded like a lawnmower.
                  </p>
                </div>
                <div class="post-comment-content-footer">
                  <p class="post-comment-content-footer-like">Like</p>
                  <p class="post-comment-content-footer-reply">Reply</p>
                  <p class="post-comment-content-footer-time">26 days ago</p>
                </div>
              </div>
            </div>
            <div class="post-comment-item">
              <div class="post-comment-avatar">
                <img
                  src="https://cdn.latteprint.com/latte/2025-08-22/1755856765688-87.jpg"
                  alt="avatar"
                />
              </div>
              <div class="post-comment-content">
                <div class="post-comment-content-header">
                  <h5 class="post-comment-content-header-name">Nyx M.</h5>
                  <p class="post-comment-content-header-text">
                    Not at all! It has a quiet whirring sound, way less noisy
                    than our robot vacuum. You can easily watch TV while it's
                    running.
                  </p>
                </div>
                <div class="post-comment-content-footer">
                  <p class="post-comment-content-footer-like">Like</p>
                  <p class="post-comment-content-footer-reply">Reply</p>
                  <p class="post-comment-content-footer-time">26 days ago</p>
                </div>
              </div>
            </div>
            <div class="post-comment-item">
              <div class="post-comment-avatar">
                <img
                  src="https://cdn.latteprint.com/latte/2025-08-22/1755856781848-108.jpg"
                  alt="avatar"
                />
              </div>
              <div class="post-comment-content">
                <div class="post-comment-content-header">
                  <h5 class="post-comment-content-header-name">Amara W.</h5>
                  <p class="post-comment-content-header-text">
                    Is it safe if the cat bites it?
                  </p>
                </div>
                <div class="post-comment-content-footer">
                  <p class="post-comment-content-footer-like">Like</p>
                  <p class="post-comment-content-footer-reply">Reply</p>
                  <p class="post-comment-content-footer-time">26 days ago</p>
                </div>
              </div>
            </div>
            <div class="post-comment-item">
              <div class="post-comment-avatar">
                <img
                  src="https://cdn.latteprint.com/latte/2025-08-22/1755856692723-75.jpg"
                  alt="avatar"
                />
              </div>
              <div class="post-comment-content">
                <div class="post-comment-content-header">
                  <h5 class="post-comment-content-header-name">Leonardo P.</h5>
                  <p class="post-comment-content-header-text">
                    Our cat has batted it and carried it around with no issues!
                    The ABS plastic is really sturdy and there are no small
                    parts that have come loose.
                  </p>
                </div>
                <div class="post-comment-content-footer">
                  <p class="post-comment-content-footer-like">Like</p>
                  <p class="post-comment-content-footer-reply">Reply</p>
                  <p class="post-comment-content-footer-time">26 days ago</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default html;
